import { InputNumber as InputNumberAntD, InputNumberProps } from 'antd';
import { FC } from 'react';

export const InputNumber: FC<InputNumberProps> = (props) => {
	return <InputNumberAntD {...props} />;
};
